import {GetQuoteType} from 'mobile/actions/checkout/checkout';

/**
 * Get option by alias value
 * @param {CartItemGlassesTypeV2Type} product - quoteItem product
 * @param {string} alias - alias for search option
 * @returns {Object} required option
 */
const getOptionByAlias = ({options}: GetQuoteType['quoteItems'][0], alias: string) =>
    options &&
    options[Object.keys(options).find(option => options[option]?.option?.alias === alias) || ''];

/**
 * Get information on product lens types for a product quoteItem
 * @param {CartItemType} product - quoteItem product
 * @returns {string} Lens type
 */
export const getLensType = (product: GetQuoteType['quoteItems'][0]): string => {
    if (product.type === 'contact_lenses') return product.lensType || '';

    if ('options' in product) return (getOptionByAlias(product, 'usage')?.sku || '').toLowerCase();

    return '';
};
